import ReactGPicker from './components/Colorpicker';

export default ReactGPicker;
